/* eslint-disable max-len */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { getBusinessCenterAccountStatusDisplayName } from '../../utils/AppUtil';
import Pill from '../../components/Pill';

const i18nMessages = defineMessages({
  active: {
    id: 'business-center-status.active',
    defaultMessage: 'Active',
  },
  stopped: {
    id: 'business-center-status.stopped',
    defaultMessage: 'Stopped',
  },
  awaitingSubscription: {
    id: 'business-center-status.awaiting-subscription',
    defaultMessage: 'Awaiting Subscription',
  },
});

const ManagedAccountRow = ({ account, handleRowClick }) => {
  const { formatMessage } = useIntl();

  const { id, displayName, status } = account;

  const statusDisplayName = getBusinessCenterAccountStatusDisplayName(
    status,
    formatMessage(i18nMessages.active),
    formatMessage(i18nMessages.stopped),
    formatMessage(i18nMessages.awaitingSubscription),
  );

  return (
    <div className="managed-account-row">
      <div onClick={() => handleRowClick(id)}>
        <span className="underlined">{displayName}</span>
      </div>
      <div>{id}</div>
      <Pill type={status}>{statusDisplayName}</Pill>
    </div>
  );
};

ManagedAccountRow.propTypes = {
  account: PropTypes.objectOf(PropTypes.any).isRequired,
  handleRowClick: PropTypes.func.isRequired,
  filterByParentName: PropTypes.func.isRequired,
};

export default ManagedAccountRow;
